import Endpoints from 'constants/Endpoints';
import { RestRequestPOST, RestRequestGET} from 'libs/RestRequest';
import {clearResource, setResource} from 'redux/actions'
import reduxStore from 'redux/store'
import { DemandValidation } from 'constants/DemandValidation';
import { setSaveStatusLoading, setSaveStatusDialog } from 'redux/actions'
import validateSection from './helpers/validateSection';

const CONTRACTOR_LIST_ID = 'contractorList';
const CONTRACTOR_ONE_PLACE_ID = 'onePlaceContractor';
const NIP_LIST_RESOURCE_ID = 'nipList';

const __get = async (url, reduxId) => {
	try {
		const res = await RestRequestGET(url)
		reduxStore.dispatch(setResource(reduxId, res))
	} catch (error) { }
}

const getList = async (id) => {
	const url = Endpoints.CONTRACTOR_GET_LIST(id);
	await __get(url, CONTRACTOR_LIST_ID)
}

const getContractorDetails = async (id, contractorDepartmentId) => {
	return await RestRequestGET(Endpoints.CONTRACTOR_GET_DETAILS(id, contractorDepartmentId))
}

const getOnePlace = async (id) => {
	const url = Endpoints.CONTRACTOR_ONEPLACE(id);
	await __get(url, CONTRACTOR_ONE_PLACE_ID)
}

const __appendContractors = (list) => {
	const { resources } = reduxStore.getState();
	const { items } = resources[CONTRACTOR_LIST_ID];

	reduxStore.dispatch(setResource(CONTRACTOR_LIST_ID, {
		items: [
			...items,
			...list,
		]
	}))
}

const __removeContractor = (element) => {
	const { resources } = reduxStore.getState();
	const { items } = resources[CONTRACTOR_LIST_ID];
	reduxStore.dispatch(setResource(CONTRACTOR_LIST_ID, {
		items: items.filter(x => x.contractor.identity !== element.contractor.identity)
	}))
}

const sendTabContractor = async (id, data) => {
	const url = Endpoints.CONTRACTOR_ADD(id);
	try {
		const res = await RestRequestPOST(url, data);
		__appendContractors(res.contractors);
		await validateSection(DemandValidation.CONTRACTOR, id, false)
	} catch (error) { }
}

const invite = async (id, values) => {
	try {
		const res = await RestRequestPOST(Endpoints.CONTRACTOR_INVITE(id), values)
		__appendContractors(res.contractors);
		await validateSection(DemandValidation.CONTRACTOR, id, false);
	} catch (error) {
	}
}

const deleteUser = async (id, data) => {
	const url = Endpoints.CONTRACTOR_REMOVE(id);
	try {
		const res = await RestRequestPOST(url, data);
		if (res.success) {
			__removeContractor(data)
			await validateSection(DemandValidation.CONTRACTOR, id,false);
		} else {
			await getList(id)
		}
	} catch (error) { }
}

const save = async (demandId) => {
	reduxStore.dispatch(setSaveStatusLoading());

	try {
		reduxStore.dispatch(setSaveStatusDialog());
		await validateSection(DemandValidation.CONTRACTOR, demandId);
	} catch (error) {
	}
}

const validate = async (id) => {
	return RestRequestGET(Endpoints.CONTRACTOR_VALIDATE(id));
}

const getNipList = async (demandId) => {
	try {
		const res = await RestRequestGET(
			Endpoints.CONTRACTOR_GET_NIP_LIST(demandId)
		)
		reduxStore.dispatch(setResource(NIP_LIST_RESOURCE_ID, res))
	} catch (error) {
	}
}
const check = async (demandId, prefix, number) => {
	const params = {
		prefix, number
	}
	return await RestRequestGET(Endpoints.CONTRACTOR_CHECK(demandId), {params});
}

const clearResources = (resource) => {
	reduxStore.dispatch(clearResource(resource));
}

export default {
	getList,
	getOnePlace,
	sendTabContractor,
	invite,
	getNipList,
	deleteUser,
	save,
	validate,
	clearResources,
	getContractorDetails,
	CONTRACTOR_ONE_PLACE_ID,
	NIP_LIST_RESOURCE_ID,
	CONTRACTOR_LIST_ID,
	check
}